import { activateDocument } from '@/store/module/competition/mutation/activateDocument';
import { addDocument } from '@/store/module/competition/mutation/addDocument';
import { addProduct } from '@/store/module/competition/mutation/addProduct';
import { deleteDocument } from '@/store/module/competition/mutation/deleteDocument';
import { setCompetition } from '@/store/module/competition/mutation/setCompetition';
import { setCompetitions } from '@/store/module/competition/mutation/setCompetitions';
import { setDocuments } from '@/store/module/competition/mutation/setDocuments';
import { setEventTypes } from '@/store/module/competition/mutation/setEventTypes';
import { setProducts } from '@/store/module/competition/mutation/setProducts';

export const mutations = {
	activateDocument,
	addDocument,
	addProduct,
	deleteDocument,
	setCompetition,
	setCompetitions,
	setDocuments,
	setEventTypes,
	setProducts
};
